import InputTypes from '../../../core/enums/InputTypes';

export const inputsAnalisePropostaMeta = [
    {
        name: 'id',
        label: 'Nº',
        type: InputTypes.STRING,
        table: { use: true },
        filter: { use: true },
        export: { use: false },
        form: { use: false },
    },
    {
        name: 'codigoDoIndicador',
        label: 'Indicador',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'meta.indicador.codgIndicador' },
        filter: { use: true, useLike: false, nameUse: 'meta.indicador.codgIndicador' },
        export: { use: true, nameUse: 'meta.indicador.codgIndicador' },
        form: { use: false },
    },
    {
        name: 'nomeDoIndicador',
        label: 'Nome Do Indicador',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'meta.indicador.nmIndicador' },
        filter: { use: true, useLike: true, nameUse: 'meta.indicador.nmIndicador' },
        export: { use: true, nameUse: 'meta.indicador.nmIndicador' },
        form: { use: false },
    },
    {
        name: 'usuarioDeSolicitacao',
        label: 'Usuário',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'meta.indicador.contaAcessoCadastro.nome' },
        filter: { use: true, useLike: true, nameUse: 'meta.indicador.contaAcessoCadastro.nome' },
        export: { use: true, nameUse: 'meta.indicador.contaAcessoCadastro.nome' },
        form: { use: false },
    },
    {
        name: 'numeroDaMeta',
        label: 'Nº Meta',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'meta.numMeta' },
        filter: { use: true, nameUse: 'meta.numMeta' },
        export: { use: true, nameUse: 'meta.numMeta' },
        form: { use: false },
    },
    {
        name: 'metaDesc',
        label: 'Meta',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'meta.descMeta' },
        filter: { use: true, nameUse: 'meta.descMeta' },
        export: { use: true, nameUse: 'meta.descMeta' },
        form: { use: false },
    },
    {
        name: 'dataApuracao',
        label: 'Apuração',
        type: InputTypes.DATE,
        table: { use: true, nameUse: 'meta.dataPrevisaoApuracao' },
        filter: { use: true },
        export: { use: true, nameUse: 'meta.dataPrevisaoApuracao' },
        form: { use: false },
    },
    {
        name: 'situacaoAvaliacaoMeta',
        label: 'Situação',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'situacaoAvaliacaoMeta.descSituacaoAvaliacaoMeta' },
        filter: { use: true, nameUse: 'situacaoAvaliacaoMeta.codgSituacaoAvaliacaoMeta' },
        export: { use: true, nameUse: 'situacaoAvaliacaoMeta.descSituacaoAvaliacaoMeta' },
        form: { use: false },
    },
    {
        name: 'analistaNegocial',
        label: 'Analista Negocial',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'analistaNegocial.nomePessoa' },
        filter: { use: true, useLike: true, nameUse: 'analistaNegocial.nomePessoa' },
        export: { use: true, nameUse: 'analistaNegocial.nomePessoa' },
        form: { use: false },
    },
    {
        name: 'dataValidacao',
        label: 'Data de Validação',
        type: InputTypes.DATE,
        table: { use: true, nameUse: 'dataValidacao' },
        filter: { use: true },
        export: { use: true, nameUse: 'dataValidacao' },
        form: { use: false },
    },
];
